// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});

/**
 * Normalizes storage URLs: rewrites the old custom domain (api.storyseed.in)
 * back to the real Supabase project host, since many URLs in the DB still
 * reference the old domain which is no longer active.
 */
export const getSafeImageUrl = (url: string | null | undefined): string | undefined => {
  if (!url) return undefined;
  if (typeof url !== 'string') return url as unknown as undefined;

  const oldHost = 'api.storyseed.in';
  const supabaseHost = 'womxlijnyxvfndbyxefc.supabase.co';

  if (url.includes(oldHost)) {
    return url.replace(oldHost, supabaseHost);
  }

  return url;
};
